// Module
var code = `<template>
  <require from="./balance-sheet-widget.scss"></require>

  <div class="balance-sheet-widget balance-sheet-widget-\${id}" mdc-size.bind="size">
    <!-- beautify ignore:start -->
    <style>
      .balance-sheet-widget-\${id} .ag-header,
      .balance-sheet-widget-\${id} .ag-cell {
        font-size: \${fontSize}px !important;
      }

      .balance-sheet-widget-\${id} .ag-cell {
        line-height: \${rowHeight}px !important;
      }
    </style>
    <!-- beautify ignore:end -->

    <ag-grid-aurelia if.bind="!error" class="\${isInDashboard && themeService.darkTheme ? 'ag-theme-balham-dark' : 'ag-theme-balham ag-theme-balham-report'}" grid-options.bind="gridOptions">

      <ag-grid-column header-name="" field="name" editable="false"></ag-grid-column>

      <ag-grid-column header-name="" field="prev" editable="false" type="rightAligned" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-grid-column header-name="" field="end" editable="false" type="rightAligned" value-formatter.bind="moneyFormatter"></ag-grid-column>

      <ag-loading-overlay-template>
        <mdc-circular-progress></mdc-circular-progress>
      </ag-loading-overlay-template>
    </ag-grid-aurelia>

    <message if.bind="error" icon="error" colour="mdc-theme--error" class="balance-sheet-widget__error">
      \${error.message}</message>
  </div>
</template>
`;
// Exports
export default code;